var _g, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5538_122261)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 50,
    height: 50,
    rx: 25,
    fill: "url(#paint0_linear_5538_122261)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1542 36.8417L32.8748 37.984C32.0364 38.3149 31.3668 38.5668 30.8681 38.7399C30.3689 38.9136 29.7888 39 29.128 39C28.113 39 27.3236 38.7514 26.7606 38.2576C26.1976 37.7618 25.916 37.1335 25.916 36.3713C25.916 36.0763 25.9364 35.7728 25.9789 35.4636C26.0218 35.154 26.0899 34.8054 26.1831 34.4157L27.2308 30.7074C27.324 30.3523 27.4032 30.0159 27.4667 29.6977C27.531 29.3815 27.562 29.0906 27.562 28.8287C27.562 28.3552 27.464 28.0239 27.2688 27.8377C27.0736 27.652 26.7011 27.5577 26.1481 27.5577C25.8773 27.5577 25.5989 27.6011 25.3152 27.6849C25.0302 27.7692 24.7866 27.8506 24.582 27.9262L24.8622 26.783C25.5485 26.5035 26.2046 26.2642 26.8321 26.0656C27.4597 25.8665 28.0526 25.7668 28.6135 25.7668C29.6214 25.7668 30.3992 26.0104 30.9453 26.4976C31.4915 26.9852 31.7645 27.6172 31.7645 28.396C31.7645 28.5572 31.7466 28.8411 31.7081 29.2469C31.6704 29.6536 31.6003 30.0263 31.4982 30.3652L30.4549 34.0587C30.3694 34.3553 30.2925 34.6945 30.2257 35.0761C30.1567 35.4552 30.1237 35.7448 30.1237 35.9392C30.1237 36.4296 30.233 36.7644 30.4522 36.9424C30.6731 37.1204 31.0534 37.209 31.5937 37.209C31.8473 37.209 32.1359 37.164 32.4566 37.0756C32.7764 36.9872 33.0096 36.9096 33.1542 36.8417ZM33.4188 21.3356C33.4188 21.9791 33.1763 22.5287 32.6889 22.9806C32.2028 23.4341 31.617 23.661 30.9317 23.661C30.2443 23.661 29.6571 23.4341 29.1654 22.9806C28.6746 22.5285 28.4287 21.9791 28.4287 21.3356C28.4287 20.6934 28.6746 20.1429 29.1654 19.6853C29.6562 19.2284 30.2445 19 30.9317 19C31.6168 19 32.2028 19.2289 32.6889 19.6853C33.1766 20.1429 33.4188 20.6935 33.4188 21.3356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.1211,
    cy: 29,
    r: 24.2188,
    stroke: "url(#paint1_linear_5538_122261)",
    strokeWidth: 1.5625
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 54,
    height: 54,
    rx: 27,
    stroke: "#FFE100",
    strokeOpacity: 0.2,
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5538_122261",
    x1: 29,
    y1: 4,
    x2: 29,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBCB10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A08D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5538_122261",
    x1: 10.249,
    y1: 11.0313,
    x2: 45.4053,
    y2: 48.5312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACC15",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDE68A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5538_122261"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 50,
    height: 50,
    rx: 25,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.fafc9f257efe1a7b7169a504f95fcc09.svg";
export { ForwardRef as ReactComponent };